module.exports = __webpack_public_path__ + "img/48.510ff68f.png";